export default "__VITE_ASSET__BJipwn_w__"